import { render, staticRenderFns } from "./OrderStatusChip.vue?vue&type=template&id=471cb956&scoped=true&"
import script from "./OrderStatusChip.vue?vue&type=script&lang=ts&"
export * from "./OrderStatusChip.vue?vue&type=script&lang=ts&"
import style0 from "./OrderStatusChip.vue?vue&type=style&index=0&id=471cb956&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471cb956",
  null
  
)

export default component.exports